module.exports = __webpack_public_path__ + "img/zhinengzhizao_zhonghuan.9d883903.png";